/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DockedTicketContainerComponent } from './components/docked-ticket-container/docked-ticket-container.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { FileAttachModule } from 'src/app/modules/file-attach/file-attach.module';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { TicketEditFormComponent } from './components/ticket-edit-form/ticket-edit-form.component';
import { MaterialModule } from 'src/app/common/material/material-module';
import { TicketEditDialogComponent } from './components/ticket-edit-dialog/ticket-edit-dialog.component';
import { CustomFieldSharedModule } from 'src/app/modules/custom-field/custom-field-shared.module';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { SharedUtilityComponentsModule } from '../utility-components/shared-utility-components.module';
import { AutomationIdDirective } from '../../shared/directives/automation-id/automation-id.directive';
import { WorkScheduleComponent } from './components/work-schedule/work-schedule.component';
import { DayChipListComponent } from './components/day-chip-list/day-chip-list.component';
import { WorkDayToggleComponent } from './components/work-day-toggle/work-day-toggle.component';
import { DurationHoursComponent } from './components/duration-hours/duration-hours.component';

@NgModule({
	declarations: [
		TicketEditFormComponent,
		TicketEditDialogComponent,
		DockedTicketContainerComponent,
		DurationHoursComponent,
		DayChipListComponent,
		WorkScheduleComponent,
		WorkDayToggleComponent,
	],
	imports: [
		CommonModule,
		MaterialModule,
		SharedUIMaterialModule,
		ReactiveFormsModule,
		FileAttachModule,
		PresentationModule,
		CustomFieldSharedModule,
		DialogReusableModule,
		SharedUtilityComponentsModule,
		AutomationIdDirective,
	],
	exports: [TicketEditFormComponent, TicketEditDialogComponent, DockedTicketContainerComponent],
})
export class DockedTicketModule {}
